// Starter photo + logo + testimonial content for TinkerShift.
// EVERYTHING here is editable — replace with real TinkerTank photography,
// real partner logos and real testimonials from Julija as they come in.

// Service hero images — Unsplash placeholders chosen to feel makerspace-adjacent.
// Swap these with Julija's own photography when available.
export const SERVICE_HERO_IMAGES = {
  strategy:
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1600&q=70",
  "professional-development":
    "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=70",
  launch:
    "https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&w=1600&q=70",
  platform:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=70",
  resources:
    "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=70",
};

// Press / credentials strip — wordmark-style text logos.
// `real` = factually verifiable from Julija's bio. Everything else is a styled placeholder.
export const PRESS_LOGOS = [
  { label: "Industrial Light + Magic", italic: true, real: true },
  { label: "TinkerTank", bold: true, real: true },
  { label: "RoboCup Jr", real: false },
  { label: "City Libraries", real: false },
  { label: "DET STEM", real: false },
  { label: "Maker Faire", italic: true, real: false },
];

// Testimonials — attributed to roles only until real quotes land.
// Replace copy + source as real testimonials come in from schools/libraries.
export const TESTIMONIALS = [
  {
    quote:
      "TinkerShift turned our underused resource room into the busiest, most loved space in the school.",
    source: "Principal",
    org: "Independent K–12, Sydney",
    color: "#FFD700",
  },
  {
    quote:
      "Our teachers walked out of PD actually excited to run a makerspace session on Monday morning.",
    source: "STEM Lead",
    org: "Catholic Secondary College",
    color: "#FF007F",
  },
  {
    quote:
      "Julija brought a decade of real delivery experience to a plan we could actually execute.",
    source: "Head of Learning",
    org: "Boys Grammar, NSW",
    color: "#0055FF",
  },
  {
    quote:
      "The equipment audit alone saved us from a $40k mistake — and showed us what we really needed.",
    source: "Director of Innovation",
    org: "Girls School, Sydney",
    color: "#00C2B8",
  },
  {
    quote:
      "The library makerspace program TinkerShift set up now runs itself. Staff feel confident, families keep coming back.",
    source: "Community Programs Lead",
    org: "City Libraries, Council",
    color: "#FF6600",
  },
  {
    quote:
      "Watching students pitch their own creative projects at our showcase — that was the moment we knew it worked.",
    source: "Principal",
    org: "Primary School, Northern Beaches",
    color: "#FFD700",
  },
];
